import { api, buildQueryParams, URLs } from '@/libs/api'
import type {
  ApiResponse,
  DailyNote,
  DailyNotePayload,
  DailyNotesData,
  DailyNotesParams,
} from '@/libs/interfaces'
import { dailyNotesApiMock } from '@/libs/mocks/handlers/dailyNotes'

const dailyNotesApiReal = {
  getDailyNotes: async (params: DailyNotesParams): Promise<DailyNote[]> => {
    const { storeID, ...queryParams } = params
    const query = buildQueryParams(queryParams)
    const response = await api.get<ApiResponse<DailyNotesData>>(
      URLs.DailyNotes.list(storeID, query),
    )
    return response.data?.data?.dailyNotes || []
  },

  createOrUpdateDailyNotes: async (
    payload: DailyNotePayload,
  ): Promise<DailyNotesData | undefined> =>
    await api
      .put<ApiResponse<DailyNotesData>>(URLs.DailyNotes.put(payload.storeID), payload.dailyNotes)
      .then((response) => response.data?.data),
}

export const dailyNotesApi: typeof dailyNotesApiReal = __IS_MOCK_MODE__
  ? dailyNotesApiMock
  : dailyNotesApiReal
